import capitalize from 'lodash/capitalize';
import { HistoryEvent, HistoryEventParameters, HistoryEventSegment } from '@api/types';
import { nameStartsWith } from '@react/constants/historyEvent/utils';

function getAudienceGroupName(segment: Maybe<HistoryEventSegment>, groupId: Maybe<string>): string {
  const group = segment?.groups.find(item => item.uuid === groupId);
  return group?.metadata?.name || '';
}

function getAudienceExportType(type?: string): string {
  return capitalize(type);
}

class AudienceBuilderExportUpdater {
  check(event: HistoryEvent): boolean {
    return nameStartsWith(event, 'audience_builder:export', 'audience_builder:segment/group');
  }

  updateParams(params: HistoryEventParameters): void {
    params.groupName = getAudienceGroupName(params.segment, params.group_uuid);
    params.audienceName = params.segment?.name;
    params.exportType = getAudienceExportType(params.export_type);
  }
}

export const audienceBuilderExportUpdater = new AudienceBuilderExportUpdater();
